import {getRouteApi} from "@tanstack/react-router";

export const offerTemplatesRouteApi = getRouteApi("/_app/sales/offers/templates/");
